import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import {connectToStores} from 'epic-alt-utils/index';
import MetaTags from '../../components/common/MetaTags';
import GalleryLightbox from '../../components/gallery/GalleryLightbox';
import {GalleryStore} from '../../stores';

@connectToStores
export default class GalleryView extends React.Component {
    static getStores() {
        return [GalleryStore];
    }

    static getPropsFromStores() {
        return { galleryData: GalleryStore.getState() };
    }

    static propTypes = {
        galleryData: PropTypes.object
    }

    state = {
        activeGalleryItem: -1
    }

    componentDidMount = () => {
        this.initGallery();
        this.scaleSizes();
        root.addEventListener('resize', this.scaleSizes);
    }

    componentWillUnmount = () => {
        root.removeEventListener('resize', this.scaleSizes);
    }

    initGallery = () => {
        this.galleryItems = this.galleryContent.getElementsByClassName('tiled-gallery-item');
        for (let i = 0; i < this.galleryItems.length; i ++) {
            const link = this.galleryItems[i].getElementsByTagName('a')[0];
            link.onclick = e => {
                e.preventDefault();
                this.setState({ activeGalleryItem: i })
            }
        }
    }

    scaleSizes = () => {
        const gallery = this.galleryContent.getElementsByClassName('tiled-gallery')[0];
        const galleryRows = gallery.getElementsByClassName('gallery-row');
        const applyScale = (el, scale) => {
            const { originalWidth, originalHeight } = el.dataset;
    
            el.style.width = `${originalWidth * scale}px`;
            el.style.height = `${originalHeight * scale}px`;
        }

        for (const galleryRow of galleryRows) {
            const galleryGroups = galleryRow.getElementsByClassName('gallery-group');
            const scale = gallery.getBoundingClientRect().width / galleryRow.dataset.originalWidth;

            applyScale(galleryRow, scale);

            for (const galleryGroup of galleryGroups) {
                const image = galleryGroup.getElementsByTagName('img')[0];

                applyScale(galleryGroup, scale);
                applyScale(image, scale);
            }
        }
    }

    handleGalleryPrevItem = () => {
        const { activeGalleryItem } = this.state;
        this.setState({
            activeGalleryItem: activeGalleryItem === 0 ? this.galleryItems.length - 1 : activeGalleryItem - 1
        });
    }

    handleGalleryNextItem = () => {
        const { activeGalleryItem } = this.state;
        this.setState({
            activeGalleryItem: activeGalleryItem === this.galleryItems.length - 1 ? 0 : activeGalleryItem + 1
        });
    }

    handleCloseGallery = () => this.setState({ activeGalleryItem: -1 })

    render() {
        const { _title, wallpaperGallery } = this.props.galleryData.data;
        const { title, content } = wallpaperGallery;
        const { activeGalleryItem } = this.state;

        return (
            <div className="GalleryView">
                <MetaTags meta={{title: _title}} />
                <h2 className="gallery-header">{ title }</h2>
                <div
                    ref={ el => this.galleryContent = el }
                    className="gallery-content"
                    dangerouslySetInnerHTML={{ __html: content }} />
                <GalleryLightbox
                    image={activeGalleryItem > -1 ? this.galleryItems[activeGalleryItem].getElementsByTagName('a')[0].href : null}
                    currentItem={activeGalleryItem + 1}
                    totalItems={this.galleryItems && this.galleryItems.length}
                    handleGalleryPrevItem={this.handleGalleryPrevItem}
                    handleGalleryNextItem={this.handleGalleryNextItem}
                    handleCloseGallery={this.handleCloseGallery} />
            </div>
        );
    }
}
